import { render, staticRenderFns } from "./SectionIntroduction.vue?vue&type=template&id=b81b82cc"
import script from "./SectionIntroduction.vue?vue&type=script&lang=js"
export * from "./SectionIntroduction.vue?vue&type=script&lang=js"
import style0 from "./SectionIntroduction.vue?vue&type=style&index=0&id=b81b82cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports